var bundles_array = [];
const ABV4_SETTINGS  = {
      'script_site_location': 'us',
      'base_url_image': 'https://cdn.shopify.com/s/files/1/1201/1688/files/',
      'images_version': '224474373',
      'upsell': {
        'enable_upsell': true,
        'cta_text': 'Add to cart',
        'checkout_popup': false,
        'heading_single_product': `Buy discounted kits that contain {% if template contains 'product' %}{{ product.title }}{% endif %}`,
        'heading_popup': "Let us help you hang on to your cha-ching 💰 upgrade and SAVE!",
        'heading_cart': "Heading Cart"
      },
      'free_gift': {
        'free_products': false,
        'free_products_id': 32669495459936, // Deluxe serum
        'free_products_quantity': 1, // how many free products should be added int
        'free_products_multiply_on': false,
        'free_products_condition': [
         32917301756000, // FaceBlaster™ White
          32917301788768, // FaceBlaster™ Black
          'Hydrogel_Essentials_Kit',
          'Beauty_Boost_Kit'
        ]
      },
      'bundle': { 
      	'subscription': false, // made false on May 24, 2023
        'upsell_bundle': false,
        'upsell_bundle_heading': "Test Heading."
      },
      'recharge_subscription': {
        enable: true
      },
      'addToCartText': 'add to cart',
      'addToCartPreventMultiClick': '.js_preventmulticlick', // $(addToCartPreventMultiClick)
      'cart_quantity_single_max': 5,
      'cart_quantity_bundle_max': 5,
      'cart_quantity': {
        'cart_quantity_single_max': 5,
        'unique_cart_quantity': {
          'conditions_variant': [
            'omgblaster', 'omgblaster-part-single-claw-wrinkle-blaster-w-handle', 
            'omgblaster-part-mini-nugget-trigger-point-w-handle', 'omgblaster-part-lymphatic-gua-sha-flusher-w-handle',
            'omgblaster-part-skin-invigorating-tool-w-handle', 'omgblaster-part-fine-line-eraser-w-handle',
            'pre-blast-cleanse-2oz-bottle', 'post-blast-cleanse-2oz-bottle', 'ashley-black-s-foot-wrap-kryo-pack', 'ashley-blacks-eye-wrap-kryopack',
            'ashley-blacks-jaw-small-area-wrap-kryopack', 'ashley-blacks-medium-kryomat', 'ashley-blacks-large-kryomat', 'fasciablaster-small-backpack',
            'sauna-suit', 'tee-shirt-distorted-logo', 'womens-tank-top-razorback-distorted-ab-logo', 'womens-tank-top-razorback-ask-me', 'shorts-blast-me',
            'sleeveless-shirt-blastersquad', 'hoodie-blastersquad', 'snapback-hat-logo', 'headband-blastersquad', 'astralign-pillow', 
            'aluminum-bottle', 'unis', 'fascia-tabs'],
          'unique_quantity': 100000
        }
      },
      'sales': {
        'bf_2022': true,
      },
      'src_set': {
        'popup_featured_images': '180,360,540,900,1080',
        'popup_thumbnail_images': null
      },
      'only_us_product_variants': [
        // 32669495459936 // Ashley Black's ™ Deluxe Serum
       ],
      'us_and_ca_product_variants': [
        // 32669495459936, // Ashley Black's ™ Deluxe Serum
      ],
      // product sold only alone
      'specific_product_in_cart': 41325096927328,
      'specific_product_in_mini_cart_massage': '<div id="blasterband_presale_note">🚀Pre-Order Special🚀<br>BlasterBand is a pre-order item and will ship in mid-March. To ensure smooth delivery, your cart will only contain the BlasterBand when added. Checkout separately for other items!</div>',
      specific_product_in_mini_cart_message_show_time: 10000,
      mini_cart: {
        notice: [
          {
            handles: ['ashleys-magic-vein-serum', 'vein-serum-1-pack', 'vein-serum-3-pack', 'vein-serum-6-pack', 'vein-serum-12-pack'],
            notice: "Due to high demand, orders containing Ashley's Magic Vein Serum will ship out in 5-7 days. Apologies for the delay.",
            excluded_country: []
          },
          {
            handles: ['faceblaster', 'skin-tightening-kit', 'pro-foot-kit', 'skin-care-kit', 'the-bare-bones-pelvic-kit', 'beginner-kit', 'face-kit', 'compact-kit', 'the-mini-kit', 'platinum-pack', 'faceblaster-duo', 'beginner-kit-1'],
            notice: "We are temporarily out of FaceBlasters, so we have substituted our ProBlaster, which is interchangeable with the FaceBlaster. It can be used on any part of your body, including your face! Please enjoy the upgrade on us!",
            excluded_country: []
          },
          {
            handles: ['all'],
            notice: '<p>Thank you for being a valued international customer! You may not have the same specials or pricing as the US, but we will save you on international shipping, and discounts built in. Global customers are loved and appreciated.</p>',
            excluded_country: ["US"]
          },
          {
            handles: ['the-nexcia-2-pack','the-nexcia-3-pack','the-nexcia-10-pack','nexcia-oil-3oz-roller','blaster-oil-essentials-3oz-roller','blaster-oil-essentials-16oz-pump','nexcia-oil-16oz-pump','blaster-oil-essentials-32oz-pump','nexcia-oil-32oz-pump','nexcia-oils-3-pack-box'],
            notice: '<p>Please allow 2–3 weeks for oil and subscription shipping. Oil orders and subscriptions will ship separately from Nexcia devices and tools.</p>',
            excluded_country: ["US"]
          }
        ]
      }
    }

var bundles_per_handle = {
    //19824951165024: ['Celebrity_Kit', "Onyx_Initiator_Kit", "Platinum_Pack", "Budget_Box", 'Quick_Start_Kit', 'De-Stress_Pack', 'Celebrity_Kit']
  };
  
  var bundle_upsell = { /*Beginner_Kit: ["Platinum_Pack", "Back_Pack"]*/};
  
  var subscribtion_products = [
    {variant_id: 32669495459936, name: 'Ashley Black\'s ™ Deluxe Serum', handle:'deluxe-serum', recharge_discount: 18, rc_price: '$48.38'},
    {variant_id: 19825070506080, name: '3.5 OZ AfterBlaster Cream™', handle: 'small-afterblaster-cream', recharge_discount: 7, rc_price: '$17.67'},
    //{variant_id: 19824951165024, name: '3.4 OZ Blaster Oil® Unscented', handle:'roll-on-blaster-oil', recharge_discount: 7, rc_price: '$17.67'},
    {variant_id: 36058796684, name: 'FaceCare Essentials Kit', handle:'facekit-products', recharge_discount: 10, rc_price: '$31.50'},
    {variant_id: 2474685038604, name: '12 OZ Blaster Oil®', handle:'12-oz-blaster-oil', recharge_discount: 10, rc_price: '$37.80'},
    {variant_id: 19824951165024, name: '3.4 OZ Blaster Oil®', handle:'small-oz-blaster-oil', recharge_discount: 7, rc_price: '$17.67'},
    {variant_id: 32669289447520, name: 'Roll On Blaster Oil', handle:'roll-on-blaster-oil', recharge_discount: 7, rc_price: '$17.67'},
    {variant_id: 39559478509664, name: 'Coffee scrub 8 oz', handle:'coffee-scrub-8-oz', recharge_discount: 20, rc_price: '$28.00'},
    {variant_id: 39559445905504, name: 'Lip scrub', handle:'lip-scrub', recharge_discount: 20, rc_price: '$17.60'},
    {variant_id: 39559433191520, name: "Ashley Black's Maximum Lip", handle:'lip-plump', recharge_discount: 20, rc_price: '$17.60'},
    {variant_id: 39559448756320, name: "LINEFIX", handle:'linefix', recharge_discount: 20, rc_price: '$31.20'},
    {variant_id: 39559445119072, name: "Forehead Hydrogel (7 pack)", handle:'forehead-hydrogel-7-pack', recharge_discount: 20, rc_price: '$23.20'},
    {variant_id: 39559436730464, name: "Hydrogel Eye Patch (7 pack)", handle:'eye-patch-hydrogel-7-pack', recharge_discount: 20, rc_price: '$23.20'},
    {variant_id: 39559433781344, name: "Hydrogel Lip Patch (7 pack)", handle:'lip-patch-hydrogels-7-pack', recharge_discount: 20, rc_price: '$23.20'},
    {variant_id: 39559439941728, name: "Hydrogel Jawline Patch (7 pack)", handle:'lifting-patch-for-jaw-7-pack', recharge_discount: 20, rc_price: '$31.20'},
    {variant_id: 39559441907808, name: "Hydrogel Décolleté Patch (7 pack)", handle:'decollete-neck-hydrogel-7-pack', recharge_discount: 20, rc_price: '$31.20'},
    {variant_id: 39559478739040, name: "Shea butter scrub 8 oz", handle:'shea-butter-scrub-8-oz', recharge_discount: 20, rc_price: '$28.00'}
  ];
  
  var fake_product_name = {
    'pre-kit-platinum-pack': "FasciaBlaster Large Backpack, Extenders, FaceBlaster, FasciaBlaster, Blastersquad Headband, Ashley Black's Kryopack™ Face Wrap, Ashley Black's Kryomat™ Small, MasterBlaster, Mini 2, FasciaBlaster® Nugget"
  }
  
  var discount_products_base_on_qty = {};
  var us_checkout_only = {'deluxe-serum': true}
  var doubled_products = {
    "replacement-extender-rings": 1
  }
  var bf_2022_sale = {
    'gift-bag': [
      {id: 39642277150816, name: 'Tissue Paper', price: 0.01}
    ]
  };
  var custom_variants_discount = {'39601898618976': 40, '39601898651744': 28.5714286, '39570680938592': 33.3333333}
  var bundle_description = {};